import { DisciplineSelector } from "../DisciplineSelector";
import { SkillSelector } from "../SkillSelector";
import type { DisciplineDraft, SkillDraft } from "./personFormSchema";

interface PersonDisciplinesSkillsSectionProps {
  organizationId?: string;
  disciplines: DisciplineDraft[];
  onDisciplinesChange: (disciplines: DisciplineDraft[]) => void;
  skills: SkillDraft[];
  onSkillsChange: (skills: SkillDraft[]) => void;
}

/** The Disciplines & Skills tab of the person form. */
export function PersonDisciplinesSkillsSection({
  organizationId,
  disciplines,
  onDisciplinesChange,
  skills,
  onSkillsChange,
}: PersonDisciplinesSkillsSectionProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <DisciplineSelector value={disciplines} onChange={onDisciplinesChange} organizationId={organizationId} />
      <SkillSelector value={skills} onChange={onSkillsChange} organizationId={organizationId} />
    </div>
  );
}
